import React from 'react';
import Typography from '@material-ui/core/Typography';
import InformationPage from '../components/InformationPage';
import { Link } from 'react-router-dom';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useUserContext } from 'common/contexts/UserContext';
import _ from 'lodash';

export default function NotFound() {
  const { user } = useUserContext();
  const LDClient = useLDClient();
  if (user && LDClient) {
    LDClient.identify({
      key: user.email,
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      custom: {
        company: _.get(user, 'company.scac', null),
        pack: _.get(user, 'company.pack', null),
        companyType: _.get(user, 'company.type', null),
        isCompanyAdmin: _.get(user, 'is_admin', false),
      },
    });
  }
  return (
    <InformationPage>
      <Typography variant="h2" paragraph color="secondary">
        Opps! This page was not found.
      </Typography>
      <Typography variant="h6" gutterBottom color="textSecondary">
        We've logged this error. Please feel free to head back to our{' '}
        <Link style={{ textDecoration: 'underline', color: 'white' }} to={'/'}>
          home page
        </Link>{' '}
        or contact support
      </Typography>
      <Typography
        variant="h6"
        gutterBottom
        color="textPrimary"
        component="a"
        href="mailto:contact@bluecargo.io"
      >
        contact@bluecargo.io
      </Typography>
    </InformationPage>
  );
}
